






















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Modal from '@/components/Modal.vue'
import { ModalSize } from '@/components/modal-size'
import AvatarOrInitials from '../../components/WebView/AvatarOrInitials.vue'
import { UserDetail } from '../../entities/user'

@Component<SuggestionAgreedUsersModal>({
    components: {
        Modal,
        AvatarOrInitials
    }
})
export default class SuggestionAgreedUsersModal extends Vue {
    @Prop(Array) public usersAgreed!: UserDetail[]

    public get modalSize() {
        return ModalSize
    }

    public get agreedCount() {
        if (!this.usersAgreed) {
            return 0
        }

        return this.usersAgreed.length
    }

    public get agreedUsersModalTitle() {
        return `${this.agreedCount} users agree`
    }

    public closeModal() {
        this.$emit('close')
    }
}
